export default {
  component: 'plant',
  name: 'Plant',
  fields: [{
      name: 'Customer ID',
      param: 'cust_id',
      type: 'number',
      required: true,
      identifier: true
    },
    {
      name: 'Plant ID',
      param: 'plant_id',
      type: 'number',
      required: true,
      identifier: true
    },
    {
      name: 'Plant Name',
      param: 'plant_name',
      type: 'text',
      textIdentifier: true
    },
    {
      name: 'City',
      param: 'city',
      type: 'text',
    },
    {
      name: 'Country',
      param: 'country',
      type: 'text',
    },
    {
      name: 'State',
      param: 'state',
      type: 'text',
    },
    {
      name: 'Zip Code',
      param: 'zip_code',
      type: 'number',
    },
    {
      name: 'Latitude',
      param: 'latitude',
      type: 'number',
    },
    {
      name: 'Longitude',
      param: 'longitude',
      type: 'number',
    },
    {
      name: 'Tilt Angle',
      param: 'tilt_angle',
      type: 'number',
    },
    {
      name: 'Mounting',
      param: 'mounting',
      type: 'number',
    },
    {
      name: 'AC Capacity',
      param: 'ac_capacity',
      type: 'number',
    },
    {
      name: 'DC Capacity',
      param: 'dc_capacity',
      type: 'number',
    },
    {
      name: 'No Of Modules',
      param: 'no_of_modules',
      type: 'number',
    },
    {
      name: 'No Of Strings',
      param: 'no_of_strings',
      type: 'number',
    },
    {
      name: 'Zone Monitoring Enable',
      param: 'zone_monitoring_enable',
      type: 'number',
    },
    {
      name: 'Threshold Value',
      param: 'threshold_value',
      type: 'number',
    },
    {
      name: 'Irradiance (Ref. device Id)',
      param: 'irr_ref_device_id',
      type: 'number',
    },
    {
      name: 'Commission Date',
      param: 'commission_date',
      type: 'number',
    },
    {
      name: 'Renew Date',
      param: 'renew_date',
      type: 'number',
    },
    {
      name: 'Membership Type',
      param: 'membership_type',
      type: 'text',
    },
    {
      name: 'DC Current Count',
      param: 'dc_current_count',
      type: 'number',
    },
    {
      name: 'Status',
      param: 'status',
      type: 'text',
      description: `It should be added as **"active"**`
    },
    {
      name: 'Logo',
      param: 'logo',
      type: 'text',
    },
    {
      name: 'Static Info',
      param: 'static_info',
      type: 'text',
    },
    {
      name: 'Channel Count',
      param: 'channel_count',
      type: 'number',
      description: `If the plant has mppt/string inverter mppt count needs to be added`
    },
    {
      name: 'SLD Tags Link',
      param: 'sld_tags_link',
      type: 'text',
    },
    {
      name: 'OM Code',
      param: 'om_code',
      type: 'text',
      description: `Daily digest data is required`
    },
    {
      name: 'Module Brand',
      param: 'module_brand',
      type: 'text',
      description: `Daily digest data is required`
    },
    {
      name: 'System Size',
      param: 'system_size',
      type: 'text',
      description: `Daily digest data is required`
    },
    {
      name: 'Inverter Brand',
      param: 'inverter_brand',
      type: 'text',
      description: `Daily digest data is required`
    },
    {
      name: 'Daily Digest Alias',
      param: 'daily_digest_alias',
      type: 'text',
      description: `Daily digest data is required`
    },
    {
      name: 'Total String Count',
      param: 'total_string_count',
      type: 'number',
    },
    {
      name: 'Config',
      param: 'config',
      type: 'json',
    },
    {
      name: 'Computed Param',
      param: 'computed_param',
      type: 'json',
    },
    {
      name: 'Name',
      param: 'name',
      type: 'text',
      description: `add plant name`
    },
    {
      name: 'Plant Static Info',
      param: 'plant_static_info',
      type: 'json',
      description: `Sample is provided "name" and "value" needs to be added
      - e.g: [{"name":"Plant Name","value":"10MW Tidel Park Solar Ltd."},{"name":"City","value":"Sayalkudi"}]`
    },
    {
      name: 'Expiry Date',
      param: 'expiry_date',
      type: 'numbers',
    },
    {
      name: 'Timezone',
      param: 'timezone',
      type: 'numbers',
      description: `Options for timezone:
      - Asia/Kolkata
      - Asia/Katmandu
      - Africa/Kigali`
    },
  ]
}
